import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import HowItWorks from "@/components/HowItWorks";
import ComparisonTeaser from "@/components/ComparisonTeaser";
import TuningProducts from "@/components/TuningProducts";
import References from "@/components/References";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";

export default function Landing() {
    useEffect(() => {
        document.title = "NA Performance · PerformanceOS – Chiptuning & Softwareoptimierung Wien";
    }, []);

    return (
        <div className="min-h-screen bg-[#0A0A0A]">
            <Navbar />
            <main>
                <Hero />
                <HowItWorks />
                <ComparisonTeaser />
                <TuningProducts />
                <References />
                <FinalCTA />
            </main>
            <Footer />
        </div>
    );
}
